import httpClient from "./httpClient";
import { Hospital, Catchment } from "../types/hospitals";
import { Group } from "../types/groups";
import { User } from "../types/users";

const END_POINT = "/hospitals";

const getHospitals = async (): Promise<Hospital[] | undefined> => {
	const response = await httpClient.get(END_POINT);
	return response.data as Hospital[];
};

const getHospital = async (id: number): Promise<Hospital | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}`);
	return response.data as Hospital;
};

const putHospital = async (
	hospital: Hospital
): Promise<Hospital | undefined> => {
	const { id } = hospital;
	const response = await httpClient.put(`${END_POINT}/${id}`, hospital);
	return response.data;
};

const createHospital = async (
	hospital: Hospital
): Promise<Hospital | undefined> => {
	const response = await httpClient.post(`${END_POINT}`, hospital);
	return response.data;
};

const removeHospital = async (id: number): Promise<undefined> => {
	const response = await httpClient.delete(`${END_POINT}/${id}`);
	return response.data as undefined;
};

const getGroups = async (id: number): Promise<Group[] | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}/groups`);
	return response.data as Group[];
};

const deleteGroup = async (
	hospitalid: number,
	groupid: number
): Promise<Group | undefined> => {
	const response = await httpClient.delete(
		`${END_POINT}/${hospitalid}/groups/${groupid}/`
	);
	return response.data as Group;
};

const postCatchments = (id: number, catchments: Catchment[]) => {
	httpClient.post(`${END_POINT}/${id}/catchments`, catchments);
};

const getUsers = async (id: number): Promise<User[] | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}/users`);
	return response.data as User[];
};

const assignUserToHospital = async (
	userid: number,
	hospitalid: number
): Promise<Hospital | undefined> => {
	const response = await httpClient.post(
		`${END_POINT}/${hospitalid}/user/${userid}`
	);
	return response.data as Hospital;
};

const removeUserFromHospital = async (
	userid: number,
	hospitalid: number
): Promise<Hospital | undefined> => {
	const response = await httpClient.delete(
		`${END_POINT}/${hospitalid}/user/${userid}`
	);
	return response.data as Hospital;
};

const inviteUsers = async (invitation): Promise<undefined> => {
	const response = await httpClient.post(
		`${END_POINT}/users/invite/connect`,
		invitation
	);
	return response.data as undefined;
};

export {
	getHospitals,
	getHospital,
	getGroups,
	deleteGroup,
	putHospital,
	createHospital,
	removeHospital,
	postCatchments,
	getUsers,
	assignUserToHospital,
	removeUserFromHospital,
	inviteUsers
};
